// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-5ef1b45e] {\n  padding-left: 1% !important;\n  padding-right: 1% !important;\n}\n.row .col-12:last-child .bord-bott[data-v-5ef1b45e] {\n  padding-bottom: 0.7em;\n  margin-bottom: 0 !important;\n  border-bottom: 1px #E2E2E2 solid;\n}\n.hovered[data-v-5ef1b45e]:hover {\n  background-color: rgb(242.25, 242.25, 242.25);\n}\n.row-card[data-v-5ef1b45e]:hover {\n  background-color: #f2f2f2;\n}", ""]);
// Exports
module.exports = exports;
